import ImageGallery from './ImageGallery';
import { galleryImages } from './Images';

function GalleryPage() {
  return (
    <div className="min-h-screen bg-[#f8f4ea] text-[#18271e]">
      <section className="border-b border-[#d8d0be] bg-[#fbf8ef]">
        <div className="mx-auto max-w-[92rem] px-6 py-14 sm:px-10 md:py-20 lg:px-16">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#8e3a2b]">
            Seasons at Emma&apos;s Court
          </p>
          <h1 className="mt-3 max-w-4xl font-serif text-5xl font-normal leading-tight text-[#0c351e] sm:text-6xl md:text-7xl">
            Garden Gallery
          </h1>
          <div className="mt-5 h-px w-24 bg-[#304536]" />
          <p className="mt-6 max-w-3xl text-lg leading-8 text-[#445044]">
            Wander through flowers, harvests, seedlings, shared plots, and the people who
            help our Philadelphia garden grow.
          </p>
        </div>
      </section>

      <section className="bg-[#f1eadc]">
        <div className="mx-auto max-w-[92rem] px-4 py-10 sm:px-8 md:py-16 lg:px-14">
          <ImageGallery images={galleryImages} showPagination showSearch />
        </div>
      </section>
    </div>
  );
}

export default GalleryPage;
